import React, { Component } from 'react'

export default ({ width, height }) => {
  return (
    <svg
      className="bell"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 20"
      width={width}
      height={height}
      preserveAspectRatio="xMidYMid meet"
    >
      <g id="Canvas" transform="translate(-210 1031)">
        <g id="bell">
          <use xlinkHref="#path0_fill" transform="translate(210 -1031)" fill="#F2F2F2"/>
        </g>
      </g>
      <defs>
        <path id="path0_fill" fillRule="evenodd" d="M 7 1.87097C 7 1.45166 7.38383 1 8 1C 8.61617 1 9 1.45166 9 1.87097L 9.00122 1.88953C 8.30353 1.80042 7.69548 1.8009 6.99875 1.88989L 7 1.87097ZM 9.95299 2.27612C 12.8686 3.12146 15 5.81189 15 9L 15 13L 15 13.2676C 15.5978 13.6134 16 14.2597 16 15C 16 16.0947 15.1205 16.984 14.0295 16.9998L 11.8921 17C 11.5345 18.6164 10.2803 20 8 20C 5.67496 20 4.41666 18.7708 4.08795 17L 2 17C 0.895432 17 0 16.1046 0 15C 0 14.2597 0.402206 13.6134 1 13.2676L 1 13L 1 9C 1 5.81189 3.13139 3.12146 6.04701 2.27612C 6.01622 2.14563 6 2.01013 6 1.87097C 6 0.837646 6.89543 0 8 0C 9.10457 0 10 0.837646 10 1.87097C 10 2.01013 9.98378 2.14563 9.95299 2.27612ZM 8 3C 4.68629 3 2 5.68628 2 9L 2 13L 14 13L 14 9C 14 5.68628 11.3137 3 8 3ZM 2.51772 14L 3.88292 14.0001L 8.02722 14.0003L 14.037 14.0007C 14.5718 14.0198 15 14.4601 15 15C 15 15.5473 14.5602 15.992 14.015 15.9999L 12 16L 11 16L 5 16L 4 16L 2.07068 16L 2 16C 1.44771 16 1 15.5523 1 15C 1 14.4477 1.44771 14 2 14L 2.00215 14L 2.0087 14L 2.03453 14L 2.13528 14L 2.51772 14ZM 10.8605 17C 10.74 17.4125 10.543 17.7863 10.276 18.0909C 9.82355 18.6072 9.10616 19 8 19C 6.84467 19 6.136 18.6469 5.70744 18.1816C 5.43321 17.8839 5.22675 17.4891 5.10963 17L 10.8605 17Z"/>
      </defs>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/visuals/Bell.js